<template>
    <div class="modal fade show d-flex flex-row justify-content-center align-items-center " tabindex="-1" role="dialog"  @click.self="close">
        <div class="modal-dialog-scrollable" role="document">
            <div class="modal-content user-logs-modal">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('simple.change_logs',{
                   name:name})}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body ">
                      <b-container fluid>
                        <b-row md="4" class="my-2 ml-auto flex-row-reverse justify-content-between">
                          <b-col md="7" sm="12" class="p-0">
                            <b-input-group>
                              <b-form-input v-model="search" :placeholder="$t('simple.type_to_search')" />
                              <b-input-group-append>
                                <b-btn :disabled="!search" @click="search = ''">{{ $t('simple.clear') }}</b-btn>
                              </b-input-group-append>
                            </b-input-group>
                          </b-col>
                          <b-col md="5" sm="12" class="p-0 mt-1">
                            <b-pagination v-if="total" :hide-goto-end-buttons="true" size="sm" :total-rows="total" :value="current" @input="(page) => updateLogPage({user_id: id , page: page })" :per-page="perpage"></b-pagination>
                          </b-col>
                        </b-row>
                        <v-wait for="logs">
                          <loading slot="waiting"/>
                          <template v-if="logs && logs.length > 0">
                            <div v-for="log in logs">
                              <p v-if="log.changed_item !== 'added' && log.changed_item !== 'removed'" class="log-desc py-2 my-0" v-html="$t('user.change_log', {
                              changed_item: log.changed_item,
                              from: log.old_value,
                              to: log.new_value,
                              changed_by: log.changed_by_name,
                              created_at: $moment($moment.utc(log.created_at)).local().format('YYYY-MM-DD HH:mm:ss'),
                              })"></p>
                              <p v-else-if="log.changed_item === 'added'" class="log-desc py-2 my-0" v-html="$t('user.user_added_to_team', {
                              user: log.user_name,
                              team: log.team_name,
                              by: log.changed_by_name,
                              created_at: $moment($moment.utc(log.created_at)).local().format('YYYY-MM-DD HH:mm:ss'),
                              })"></p>
                              <p v-else-if="log.changed_item === 'removed'" class="log-desc py-2 my-0" v-html="$t('user.user_removed_form_team', {
                              user: log.user_name,
                              team: log.team_name,
                              by: log.changed_by_name,
                              created_at: $moment($moment.utc(log.created_at)).local().format('YYYY-MM-DD HH:mm:ss'),
                              })"></p>
                              <hr class="my-0"/>
                            </div>
                          </template>
                          <template v-else>
                            <p class="log-desc py-2 my-0 text-center">
                              {{ $t('user.no_changes_found_for_user') }}
                            </p>
                          </template>
                        </v-wait>
                      </b-container>
                </div>

            </div>
        </div>
    </div>
</template>
<script>


import {mapActions, mapGetters} from "vuex";

export default {
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      required: true
    },
  },
    mounted: function () {
        // Component mounted
        console.log('User logs Modal mounted');
    },

    destroyed() {
        // Component destroyed
        console.log('User logs Modal destroyed.');
    },
  created: function() {
    // Component created
    this.fetchUserLogs({user_id:this.id});
  },
  data: function() {
    return  {}
  },
  methods: {
    close() {
      this.search = ''
      this.$emit('close');
    },
    // Actions
    ...mapActions('Users', [
      'fetchUserLogs',
      'updateLogPage',
      'updateSearchUserLogs'
    ]),

  },

  computed: {
    // Map getters
    ...mapGetters({
      logs: 'Users/getUserLogs',
      total: 'Users/getLogsTotal',
      current: 'Users/getLogsCurrent',
      perpage: 'Users/getLogsPerPage',
      getSearchUserLogs: 'Users/getSearchUserLogs',

    }),
    search:{
      get(){
        return this.getSearchUserLogs;
      },
      set(newSearch) {
        if (this.getSearchUserLogs !== newSearch) {
          this.updateSearchUserLogs(newSearch);
          this.fetchUserLogs({
            user_id:this.id,
            search: newSearch,
          });
        }
      }
    },
  },

}
</script>
